import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';

import Button from 'partial/components/Button';
import FormInput from 'partial/components/form/FormInput';
import { useUpdateRequest } from '../hooks';

export const useOpenUpdateRequest = () => {
  const createModal = useCreateModal();

  const openUpdateRequestModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <UpdateRequest data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openUpdateRequestModal;
};

const status = {
  approve: 'APPROVED',
  reject: 'REJECTED',
};

function UpdateRequest({ onClose, data }) {
  const { cb } = data;
  const [remarks, setRemarks] = useState('');
  const [isLoading, update] = useUpdateRequest({
    onSuccess: () => {
      onClose();
      cb();
    },
    onError: onClose,
  });

  const submit = () => {
    update({
      uuid: data?.uuid,
      payload: { status: status?.[data?.action], remarks },
    });
  };

  const isDisabled = useMemo(
    () => (data?.action === 'approve' ? false : remarks.length === 0),
    [data?.action, remarks],
  );

  return (
    <ModalCard
      size="sm"
      title={`CONFIRM ${data?.action === 'approve' ? 'APPROVAL' : 'REJECTION'}`}
      onClose={onClose}
    >
      <div className="p-5 w-full">
        <p className="text-sm font-semibold mb-6">
          Are you sure you want to {data?.action} this upgrade request?
        </p>
        <FormInput
          name="remarks"
          onSetFieldValue={(_, value) => setRemarks(value)}
          value={remarks}
          label={data?.action === 'approve' ? 'Remarks (Optional)' : 'Remarks'}
          required={data?.action === 'reject'}
        />
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            disabled={isLoading || isDisabled}
            outline
            className="uppercase"
            onClick={submit}
          >
            confirm
          </Button>
        </div>
      </div>
    </ModalCard>
  );
}

UpdateRequest.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateRequest;
